import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Chip,
  Stack,
  Dialog,
  DialogContent,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GroupsIcon from "@mui/icons-material/Groups";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import PsychologyIcon from "@mui/icons-material/Psychology";
import DiamondIcon from "@mui/icons-material/Diamond";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HubIcon from "@mui/icons-material/Hub";
import DescriptionIcon from "@mui/icons-material/Description";
import GavelIcon from "@mui/icons-material/Gavel";
import BalanceIcon from "@mui/icons-material/Balance";
import InsightsIcon from "@mui/icons-material/Insights";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import { LuCircleCheckBig } from "react-icons/lu";
import HighTicketForm from "./HighTicketForm";
import LuxurySalesMasteryForm from "./LuxurySalesMasteryForm";
import SalesArchitectureForm from "./SalesArchitectureForm";
import CoachingPopup from "./CoachingPopup";
import { HighTicketDealspdf, luxurysalesmasterypdf, PersonalisedMentoringpdf } from "../../../../assets";


/* =========================
   Card Props
========================= */
interface ProgramCardProps {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  features: { icon: React.ReactNode; text: string }[];
  bottomFeatures: { icon: React.ReactNode; text: string }[];
  buttonText: string;
  onClick?: () => void;
  onKnowMore?: () => void;
}

const gold = "#C6A15B";
const darkBg = "#0A0F1C";
const cardBg = "rgba(255,255,255,0.05)";
/* =========================
   Program Card Component
========================= */
const ProgramCard: React.FC<ProgramCardProps> = ({
  title,
  subtitle,
  description,
  image,
  features,
  bottomFeatures,
  buttonText,
  onClick,
  onKnowMore
}) => {

  const [showAll, setShowAll] = useState(false);
  // const [openPopup, setOpenPopup] = useState(false);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget;

    if (target.scrollTop > 5) {
      setShowAll(true);
    }
  };

  // const handleKnowMore = () => {
  //   setOpenPopup(true);
  // };

  // const handleClosePopup = () => {
  //   setOpenPopup(false);
  // };

  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        // height: "100vh",
        height: { xs: "auto", md: "auto", lg: "500px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        color: "#fff",
        overflow: "hidden",
        p:{xs:2,md:2,lg:6},

        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "right center",
        borderRadius:"30px",

        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background: `
            linear-gradient(
              90deg,
              #06172D 0%,
              rgba(6,23,45,0.98) 20%,
              rgba(6,23,45,0.95) 40%,
              rgba(6,23,45,0.85) 55%,
              rgba(6,23,45,0.65) 70%,
              rgba(6,23,45,0.35) 85%,
              rgba(6,23,45,0.1) 100%
            )
          `
        }
      }}
    >

      {/* {popular && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            overflow: "hidden",
            width: 120,
            height: 120,
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 30,
              right: -38,
              transform: "rotate(45deg)",
              background: "linear-gradient(135deg,#0f63a5,#1c88e5)",
              color: "#fff",
              width: 170,
              textAlign: "center",
              fontWeight: 700,
              fontSize: "0.75rem",
              letterSpacing: 1,
              py: 0.6,
              borderRadius: "6px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
            }}
          >
            MOST POPULAR
          </Box>
        </Box>
      )} */}

      {/* CONTENT AREA */}
      <Box sx={{ position: "relative", zIndex: 2, }}>

        {/* ICON + TITLE */}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            mb: 2,
          }}
        >
          <Box
            sx={{
              minWidth: 60,
              height: 60,
              borderRadius: "16px",

              background: `linear-gradient(135deg, #1a1f2e, #0a0f1c)`,

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              color: "white",

              boxShadow: `
      0 0 15px rgba(198,161,91,0.3),
      inset 0 0 10px rgba(198,161,91,0.2)
    `,
            }}
          >
            {icon}
          </Box>

          <Box>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                textAlign: "start",
                fontSize: { xs: "20px", md: "18px" },
              }}
            >
              {title}
            </Typography>

            {subtitle && (
              <Typography
                variant="body2"
                sx={{
                  color: "#0f63a5",
                  fontWeight: 600,
                  textAlign: "start",
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box> */}
        {/* TITLE */}
        <Typography
        variant="h4"
          sx={{
            // fontSize: "48px",
            fontWeight: 800,
            lineHeight: 1.2,
            mb: 1,
            color:'white'
          }}
        >
          {title}
        </Typography>
        {/* SUBTITLE */}
        <Typography sx={{ color: "#4DA3FF", mb: 2 }}>
          {subtitle}
        </Typography>

        {/* DESCRIPTION */}
        <Typography variant="body2" sx={{ color: "#fff", mb: 4,minHeight:{xs:"auto",md:"45px"} }}>
          {description}
        </Typography>

        {/* FEATURES (LEFT ALIGNED FIX) */}
        <Grid container spacing={2}>
          {features.map((f, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Box sx={{ color: "#4DA3FF", mt: "2px" }}>{f.icon}</Box>
                <Typography variant="body2" sx={{color:"white",textAlign:"start"}}>{f.text}</Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ position: "relative", zIndex: 2,  pt: 2 }}>
              
              {/* BOTTOM FEATURES */}
              <Box
                sx={{
                  p: 2,
                  borderRadius: "12px",
                  background: "rgba(255,255,255,0.05)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.15)"
                }}
              >
                <Grid container spacing={1}>
                  {bottomFeatures.map((b, i) => (
                    <Grid item xs={6} key={i}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Box sx={{ color: "#4DA3FF" }}>{b.icon}</Box>
                        <Typography variant="body2" sx={{color:"white",textAlign:"start"}}>{b.text}</Typography>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Box>
      
              {/* BUTTONS */}
              <Stack 
              direction={{ xs: "column", sm: "row" }} 
               spacing={2} mt={3}>
                <Button
                 onClick={onKnowMore}
                  variant="outlined"
                  sx={{
                    borderColor: "#0f63a5",
                    color: "#0f63a5",
                    textTransform: "none"
                  }}
                >
                  Download Brochure
                </Button>
      
                <Button
                  variant="contained"
                  onClick={onClick} 
                  sx={{
                    backgroundColor: "#0f63a5",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#0f63a5" }
                  }}
                >
                 {buttonText}
                </Button>
              </Stack>
            </Box>

      {/* DESCRIPTION */}
      {/* <Typography
          variant="body2"
          sx={{
            color: "#555",
            lineHeight: 1.2,
            mb: 2,
            textAlign: "start",
            fontWeight: 700
          }}
        >
          {description}
        </Typography> */}

      {/* FEATURES WITH SCROLL REVEAL */}
      {/* <Box
          sx={{

            pr: 1,

          }}
        >
          <Stack spacing={1.0}>
            {features.map((feature, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{
                    minWidth: 22,
                    mt: "3px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LuCircleCheckBig size={18} color="#0f63a5 " />
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "start",
                    fontSize: { xs: "0.95rem", md: "0.9rem" },
                  }}
                >
                  {feature}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box> */}

      {/* FRAMEWORKS & TECHNIQUES */}
      {/* <Box sx={{ mt: 2.5, mb: 2 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              color: "#0f63a5",
              mb: 1,
              textAlign: "start",
              fontSize: "0.95rem",
            }}
          >
            Frameworks & Techniques
          </Typography>
          <Stack spacing={1.0}>
            {frameworks.map((framework, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{
                    minWidth: 22,
                    mt: "3px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LuCircleCheckBig size={18} color="#0f63a5" />
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "start",
                    fontSize: { xs: "0.95rem", md: "0.9rem" },
                  }}
                >
                  {framework}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box> */}





      {/* <Stack spacing={2}>
        <Button
          fullWidth
          onClick={onKnowMore}
          sx={{
            borderRadius: "30px",
            border: `1px solid #000`,
            color: "white",
            textTransform: "none",

            "&:hover": {
              background: "rgba(198,161,91,0.1)",
              borderColor: gold,
            },
          }}
        >
          Download Brochure
        </Button>

        <Button
          fullWidth
          onClick={onClick} // ✅ existing dialog
          // variant={popular ? "contained" : "outlined"}
          sx={{
            borderRadius: "10px",
            fontWeight: 600,
            // backgroundColor: popular ? "#0f63a5" : "transparent",
            borderColor: "#0f63a5",
            // color: popular ? "white" : "#0f63a5",
            "&:hover": {
              backgroundColor: "#0c4e82 !important",
              borderColor: "#0c4e82",
              color: "white",
            },
          }}
        >
          {buttonText}
        </Button>
      </Stack> */}
    </Paper>
  );
};


/* =========================
   Main Section
========================= */
const PremiumPrograms: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState<string | null>(null);
  const [openCoaching, setOpenCoaching] = useState(false);
  const [coachingPdf, setCoachingPdf] = useState("");

  const handleOpen = (formType: string) => {
    setSelectedForm(formType);
    setOpen(true);
  };

  const handleOpenCoaching = (pdf: string) => {
    setCoachingPdf(pdf);
    setOpenCoaching(true);
  };

  const handleCloseCoaching = () => {
    setOpenCoaching(false);
    setCoachingPdf("");
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedForm(null);
  };
  return (
    <Box
      id="premium-programs"
      sx={{
        py: 4,
        background:
          "linear-gradient(180deg, #f8fbff 0%, #eef5fc 100%)",
        // px: { xs: 2, md: 10 },

        borderTop: "2px solid rgba(15,99,165,0.25)",

        boxShadow: "0 -20px 40px rgba(15,99,165,0.05)",
        height: { xs: "auto", md: "auto" }
      }}
    >
      <Container maxWidth="xl" sx={{ px:{xs:2,md:2,lg:10}}}>
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" fontWeight={700} >
            Premium Coaching Programs
          </Typography>

          <Typography variant="h6" color="#666">
            Structured Pathways for Sales Professionals & Organizations
          </Typography>

          <Typography variant="body2" color="#666" mt={1}>
            Whether you are an individual sales professional or leading a
            revenue team, choose the level that matches your ambition.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <ProgramCard
              title="High-Ticket Closer Academy"
              subtitle="(Group Growth Program)"
              description="For professionals building authority in high-value sales conversations."
              image="https://dprstorage.b-cdn.net/RW/leadgen/highticket.png"
              features={[
                { icon: <GavelIcon />, text: "High-ticket closing frameworks" },
                { icon: <PsychologyIcon />, text: "Buyer psychology & decision mapping" },
                { icon: <HandshakeIcon />, text: "Negotiation & objection systems" },
                { icon: <HubIcon />, text: "Live deal simulations" }
              ]}
              bottomFeatures={[
                { icon: <BalanceIcon />, text: "Consultative Selling" },
                { icon: <InsightsIcon />, text: "Decision-Guidance Closing" },
                { icon: <SyncAltIcon />, text: "Value Anchoring" },
                { icon: <DescriptionIcon />, text: "Objection Reframing" }
              ]}
              buttonText="Enquiry Now"
              onClick={() => handleOpen("highTicket")}
              onKnowMore={() => handleOpenCoaching(HighTicketDealspdf)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProgramCard
              title="Luxury Sales Mastery"
              subtitle="(Enterprise Sales Training Program)"
              description="This is where we integrate your Uber Luxury + Sales Mastery split, but keep it clean and powerful."
              image="https://dprstorage.b-cdn.net/RW/leadgen/luxurysales.png"
              features={[
                { icon: <PsychologyIcon />, text: "Luxury buyer psychology systems" },
                { icon: <DiamondIcon />, text: "Property positioning frameworks" },
                { icon: <HandshakeIcon />, text: "Negotiation & conversion strategies" },
                { icon: <HubIcon />, text: "Pipeline & follow-up architecture" }
              ]}
              bottomFeatures={[
                { icon: <GroupIcon />, text: "Luxury Buyer Mapping" },
                { icon: <HomeIcon />, text: "Site Visit Conversion" },
                { icon: <DiamondIcon />, text: "Value Positioning" },
                { icon: <InsightsIcon />, text: "Pipeline Discipline System" }
              ]}
              buttonText="Enquiry Now"
              onClick={() => handleOpen("luxury")}
              onKnowMore={() => handleOpenCoaching(luxurysalesmasterypdf)}
            />
          </Grid>



          {/* <Grid item xs={12} md={4}>
            <ProgramCard
              icon={<CardGiftcardIcon />}
              title="1–1 Personalised Mentoring"
              subtitle="(Private Intensive | 2 Days | 4 Hours Each)"
              description="A focused, high-impact mentoring experience designed to rebuild how you position, communicate, and close."
              features={[
                " Personal branding & authority building",
                "Communication & confidence systems",
                " Negotiation & closing techniques",
                "NLP & performance coaching",


              ]}
              frameworks={[
                "Personal Brand Formula",
                "Conversation Flow System",
                "Value-Based Negotiation",
                "NLP Influence Models",
              ]}

              buttonText="Apply Now"
              onClick={() => handleOpen("masterclass")}
              onKnowMore={() => handleOpenCoaching(PersonalisedMentoringpdf)}
            />
          </Grid> */}
        </Grid>
      </Container>

      <Dialog open={open}
        onClose={handleClose}
        // maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "30px",
            background:
              // "linear-gradient(145deg, #0c1f33, #0f2e4d)",
              "linear-gradient(145deg, #103964, #2681dd)",
            boxShadow:
              "0 40px 120px rgba(0,0,0,0.6)",
            overflow: "hidden",
            // maxWidth: { xs: "99%", md: "60%" },
            width: { xs: "100%", md: "60%" },   // 👈 FIXED
            maxWidth: { xs: "95%", md: "60%" }, // 👈 FIXED
            margin: { xs: 0, md: "auto" },
          },
        }}>
        <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
          {selectedForm === "highTicket" && <HighTicketForm onClose={handleClose} />}
          {selectedForm === "luxury" && <LuxurySalesMasteryForm onClose={handleClose} />}
          {selectedForm === "masterclass" && <SalesArchitectureForm onClose={handleClose} />}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCoaching}
        onClose={handleCloseCoaching}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "30px",
            background: "linear-gradient(145deg, #3b3f4d, #1f2125)",
            boxShadow: "0 50px 140px rgba(0,0,0,0.6)",
            overflow: "hidden",
            border: "1px solid rgba(20, 149, 209, 0.6)",


          },
        }}
      >
        <DialogContent sx={{ p: { xs: 2, md: 4 }, background: "transparent" }}>
          <CoachingPopup
            handleClose={handleCloseCoaching}
            pdfUrl={coachingPdf}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PremiumPrograms;
